export const UPDATE_PAGINATOR = 'UPDATE_PAGINATOR';
export const UPDATE_FETCHED_COURSES = 'UPDATE_FETCHED_COURSES';
export const SET_CACHED_STATE = 'SET_CACHED_STATE';
export const SET_ORDER_BY = 'SET_ORDER_BY';
export const SET_PROCESSING_STATE = 'SET_PROCESSING_STATE';